import { CButtonClassname, EButtonColor, SectionSubtitle } from '@web_opxp/components';
import { AuthSelectors, NextObStepLink } from '@web_opxp/features';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import { useSelector } from 'react-redux';
import ENV from '../../base/env';
import MoneybackGuarantee from '../../components/moneyback/MoneybackGuarantee';

export default function Success() {
  const token = useSelector(AuthSelectors.getToken);
  const { language, t } = useTranslation();
  const illustrationSrc = `${ENV.AssetsBaseUrl}/feature/premium_benefits.png`;
  const title = language ? t('Checkout.Success.Title') : '';
  const subtitle = language ? t('Checkout.Success.SubtitleHtml') : '';
  const ctaLabel = language ? t('Checkout.Success.CTA') : '';
  return (
    <>
      <div className="panel" data-testid="success-panel">
        <div className="illustration">
          <img src={illustrationSrc} alt={title} />
        </div>
        <div className="content">
          <h3 className="title">{title}</h3>
          <SectionSubtitle wrapperTag="div">{renderStringToReact(subtitle, ETagType.div)}</SectionSubtitle>
          <div className="buttons">
            <NextObStepLink
              currentStepName="subscribe"
              language={language}
              session={token}
              className={`${CButtonClassname} ${EButtonColor.blue}`}
            >
              {ctaLabel}
            </NextObStepLink>
          </div>
        </div>
      </div>
      <MoneybackGuarantee />
    </>
  );
}
